var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.2 30",
    style: {
      enableBackground: "new 0 0 28.2 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#32F7A0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,30c-1,0-1.8-0.5-2.2-1.5c-0.5-1.2,0-2.7,1.3-3.2l5.3-2.2l-8.8-1.9c-1.1-0.2-1.8-1.1-1.9-2.2 C3.6,18,4.3,17,5.3,16.6l8.1-2.8L2.1,12.4c-1.1-0.1-2-1.1-2.1-2.2c-0.1-1.1,0.6-2.2,1.7-2.5L25,0.1c1.3-0.4,2.6,0.3,3,1.5 c0.4,1.3-0.3,2.6-1.5,3L13.4,9l10.8,1.4c1.1,0.1,2,1,2.1,2.1c0.1,1.1-0.5,2.2-1.6,2.5l-9.7,3.3l7.8,1.6c1,0.2,1.8,1.1,1.9,2.1 c0.1,1-0.5,2-1.5,2.4L11,29.8C10.7,29.9,10.3,30,10,30z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxlogo);
export default __webpack_public_path__ + "static/media/boxlogo.5fd7b636e92d6bce3fb7119af53ac804.svg";
export { ForwardRef as ReactComponent };